const rex = new RegExp(`[\\s\\_\\-\\|]`, 'g')

/**
 * pa|ge_Na-me_Te st=>PaGeNaMeTeSt
 * @param str
 * @returns
 */
export const toPascal = (str: string): string => {
  const arr = str.split(rex)
  const res = arr.reduce((sum, item) => {
    const [head, ...tail] = (item || '').toLowerCase().split('')
    const tmp = [(head || '').toUpperCase(), ...tail].join('')
    sum.push(tmp)
    return sum
  }, [] as string[])
  return res.join('')
}

/**
 * pa|ge_Na-me_Te st=>paGeNaMeTeSt
 * @param str
 * @returns
 */

export const toCamel = (str: string): string => {
  const arr = str.split(rex)
  const res = arr.reduce((sum, item, index) => {
    const [head, ...tail] = (item || '').toLowerCase().split('')
    const tmp = [index === 0 ? head || '' : (head || '').toUpperCase(), ...tail].join('')
    sum.push(tmp)
    return sum
  }, [] as string[])
  return res.join('')
}
